import { GlobalsQueryContext } from "common/GlobalsQueryProvider";
import { useContext } from "react";

const useGlobalsQueryLoader = () => useContext(GlobalsQueryContext)
export default useGlobalsQueryLoader;